export const namespaced = true;

const DefaultReloadStatesData = {
    reloadStates: {
        submission: false,
        authorized: false,
        receipt: false,
        replacement: false,
        invoice: false,
        bill: false,
        complete: false
    }
};

export const state = {
    reloadStates: DefaultReloadStatesData.reloadStates
}

export const getters = {
         getAllStates: (state) => {
           return state.reloadStates;
         },
         getSubmissionState: (state) => {
           return state.reloadStates.submission;
         },
       };

export const actions = {
    setSingleState({commit}, data) {
        try{
            commit('SET_LOADING_STATE', data);
        } catch(err) {
            return err.response.data.error;
        }        
    }
}

const mutations = {
    SET_LOADING_STATE: (state, data) => {
        let preState = {...state.reloadStates};
        preState[data.name] = data.value;
        state.reloadStates = Object.assign(preState, {});
    }
}

export default {
    state,
    actions,
    getters,
    mutations,
    namespaced
}